<info-page>
  <ng-template #image><img alt="" src="/assets/images/evaluation/expired.png" /></ng-template>
  <ng-template #title>Evaluation time period has expired</ng-template>
  <ng-template #description>
    You had eight weeks to evaluate the consultant - four weeks before the end of the contract and four weeks after the
    contract termination. If you have any questions, please
    @if (evaluationData?.ContactEmail) {
      <a href="mailto:{{ evaluationData?.ContactEmail }}">contact your Darize Agent</a>
    } @else {
      contact your Darize Agent
    }
    .
  </ng-template>
</info-page>
